import Vue from 'vue'

import Autocomplete from './components/shared/Autocomplete'
import CustomSelect from '@/components/shared/CustomSelect'
import DataTables from './components/shared/DataTables'
import DocAutocomplete from './components/shared/DocAutocomplete'
import Dropdown from '@/components/shared/Dropdown'
import DropdownList from '@/components/shared/DropdownList'
import FavoriteRoute from '@/components/shared/layout/FavoriteRoute'
import FormGroup from '@/components/shared/layout/FormGroup'
import GridLayout from '@/components/shared/layout/GridLayout'
import GridLayoutWithFilters from '@/components/shared/layout/GridLayoutWithFilters'
import InfoBar from '@/components/shared/layout/InfoBar'
import InputCheck from '@/components/shared/InputCheck'
import MainContent from '@/components/shared/layout/MainContent'
import NewDatatable from '@/components/shared/NewDatatable'
import PatientIdentification from './components/shared/patient/components/PatientIdentification'
import PatientForm from './components/shared/patient/components/PatientForm'
import PatientModal from './components/shared/patient/PatientModal'
import ProfilesBar from '@/components/shared/layout/ProfilesBar'
import SaveProfileModal from '@/components/shared/layout/SaveProfileModal'
import SearchGroup from '@/components/shared/layout/SearchGroup'
import SearchInput from '@/components/shared/layout/SearchInput'
import Section from '@/components/shared/layout/Section'
import Steps from '@/components/shared/layout/Steps'
import Subtitle from '@/components/shared/layout/Subtitle'
import Title from '@/components/shared/layout/Title'
import ToolBar from '@/components/shared/layout/ToolBar'

import HierarchySelect from '@/components/shared/HierarchySelect'

Vue.component('Autocomplete', Autocomplete)
Vue.component('CustomSelect', CustomSelect)
Vue.component('DataTables', DataTables)
Vue.component('DocAutocomplete', DocAutocomplete)
Vue.component('Dropdown', Dropdown)
Vue.component('DropdownList', DropdownList)
Vue.component('FavoriteRoute', FavoriteRoute)
Vue.component('FormGroup', FormGroup)
Vue.component('GridLayout', GridLayout)
Vue.component('GridLayoutWithFilters', GridLayoutWithFilters)
Vue.component('HierarchySelect', HierarchySelect)
Vue.component('InfoBar', InfoBar)
Vue.component('InputCheck', InputCheck)
Vue.component('MainContent', MainContent)
Vue.component('NewDatatable', NewDatatable)
Vue.component('PatientIdentification', PatientIdentification)
Vue.component('PatientForm', PatientForm)
Vue.component('PatientModal', PatientModal)
Vue.component('ProfilesBar', ProfilesBar)
Vue.component('SaveProfileModal', SaveProfileModal)
Vue.component('SearchGroup', SearchGroup)
Vue.component('SearchInput', SearchInput)
Vue.component('Section', Section)
Vue.component('Steps', Steps)
Vue.component('Subtitle', Subtitle)
Vue.component('Title', Title)
Vue.component('ToolBar', ToolBar)
